"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSepaDebitNoticeMockData = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const country_1 = require("../../internationalization/enums/country");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const icons_1 = require("../icons");
const format_mock_currency_1 = require("./format-mock-currency");
const buildSepaDebitNoticeMockData = ({ orgName, color, isDarkMode, firstName = "Alex", locale = "en", subject, expectedDebitDate = null, }) => {
    const labels = (0, email_templates_1.getEmailLabels)(locale);
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color, isDarkMode ? "dark" : "light");
    return {
        labels,
        theme,
        iconZeffyLogo: theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight,
        orgName,
        firstName,
        subject: subject ?? labels.sepaDebitNoticeSubject,
        lang: locale,
        sepaDebit: {
            mandateReference: "EXAMPLE-MANDATE-2026",
            maskedIban: "•••• 3000",
            totalAmount: (0, format_mock_currency_1.formatMockCurrencyAmount)(2750, { locale, country: country_1.OrganizationCountry.Germany }),
            currency: "EUR",
            creditorName: "Example SEPA Creditor",
            creditorId: "DE98ZZZ09999999999",
            creditorEmail: "support@example.org",
            creditorPhone: "+49 30 123456",
            creditorAddress: "Example Street 1, 10115 Berlin, Germany",
            expectedDebitDate,
        },
    };
};
exports.buildSepaDebitNoticeMockData = buildSepaDebitNoticeMockData;
